import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PRINT_SELECT_IMAGES_VALIDATION, PrintSelectImageData, ThumbImagesDataEntity } from "../hooks/use-print-select-images";
import './print-select-use-images.card.scss';
import { FaTimes } from "react-icons/fa";
import { Button } from "../../../../ui/button/button";

type Props = {
  data: PrintSelectImageData,
  saveThumbImageList: ThumbImagesDataEntity[],
  onInputSelect: (id: string, count: number) => void,
}

export const PrintSelectUseImageCard = (props: Props) => {
  const {
    data,
    saveThumbImageList,
    onInputSelect,
  } = props;

  const viewDate = useMemo(() => {
    const now = (new Date()).getFullYear();
    return `${now}/01/01`;
  }, []);
  // const [src, setSrc] = useState('');
  const src = useMemo(() => {
    const target = saveThumbImageList.find((v) => v.imageId === data.thumbId);
    if (data.thumbId && target) {
      return target.image;
    }

    return data.trimmingStatus === 2 ? undefined : data.thumbBase64;
  }, [
    data,
    saveThumbImageList,
  ]);
  const cnt = useRef<HTMLDivElement>(null);
  const inputContainer = useRef<HTMLInputElement>(null);
  const [count, setCount] = useState('');

  const handleChangeInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!data.count) return;
    setCount(e.target.value);
  }, [data]);
  const handleKeydownInput = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e.nativeEvent.isComposing && e.key === 'Enter') {
      e.preventDefault();
      inputContainer.current?.blur();
    }
  }, []);
  const inputCount = useCallback((value: number) => {
    let resultValue = value;
    if (value < PRINT_SELECT_IMAGES_VALIDATION.min) {
      resultValue = PRINT_SELECT_IMAGES_VALIDATION.min;
    }
    if (value > PRINT_SELECT_IMAGES_VALIDATION.max) {
      resultValue = PRINT_SELECT_IMAGES_VALIDATION.max;
    }
    onInputSelect(data.id, resultValue);

  }, [data, onInputSelect]);
  const handleBlurInput = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const value = Number(e.target.value) || 0;
    inputCount(value);
  }, [inputCount]);

  const handleClickDelete = useCallback(() => {
    inputCount(0);
  }, [inputCount]);

  useEffect(() => {
    setCount(`${data.count ?? ''}`);
  }, [data.count]);

  return (
    <div
      ref={cnt}
      className="print_select_use_image_wrapper"
    >
      <div
        className={`print_select_use_image`}
      >
        { src ? (
          <>
            <img src={src} alt={data.orgFilename} />
            <Button
              className="delete_btn"
              label={(<FaTimes fill="#fff" />)}
              onClick={() => handleClickDelete()}
            />
            <input
              ref={inputContainer}
              value={count}
              type="number"
              min={0}
              max={9999}
              onChange={handleChangeInput}
              onKeyDown={handleKeydownInput}
              onBlur={handleBlurInput}
            />
          </>
        ) : (
          <div
            className="loading_popup__dots"
            style={{ fontSize: '0.5rem', animationDuration: `${1}s`, WebkitAnimationDuration: `${1}s` }}
          />
        ) }
      </div>
    </div>
  )

}
